import React from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import "./ServiciosNosotros.css";

const ServiciosNosotros = () => {
  const isMobile = window.innerWidth < 992;

  const items = [
    { icon: "fas fa-check-circle", text: "Calidad<br />Garantizada" },
    { icon: "fas fa-truck", text: "Entrega<br />Inmediata" },
    { icon: "fas fa-handshake", text: "Atención<br />Personalizada" },
    { icon: "fas fa-globe", text: "Envíos a<br />Todo el País" },
  ];

  return (
    <div className="servicios-section">
      <Container>
        {isMobile ? (
          <Carousel>
            {items.map((item, index) => (
              <Carousel.Item key={index}>
                <Row className="justify-content-center">
                  <Col xs={12}>
                    <div className="servicio-item text-center">
                      <div className="servicio-icon-circle">
                        <i className={`${item.icon} servicio-icon`}></i>
                      </div>
                      <p
                        className="servicio-text"
                        dangerouslySetInnerHTML={{ __html: item.text }}
                      />
                    </div>
                  </Col>
                </Row>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <Row className="text-center servicios-features">
            {items.map((item, index) => (
              <Col md={3} key={index} className="servicio-wrapper">
                <div className="servicio-item">
                  <div className="servicio-icon-circle">
                    <i className={`${item.icon} servicio-icon`}></i>
                  </div>
                  <p
                    className="servicio-text"
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                </div>
                {index < items.length - 1 && <div className="servicio-divider"></div>}
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default ServiciosNosotros;
